module.exports = __webpack_public_path__ + "static/media/icon-live-ic-edit.3bd4efd9.svg";